import React, { useRef , useEffect, useState} from "react";
import { Link } from "react-router-dom";
import "./Banner.css";
import Banner1 from './../images/banner1.png'
import Bright from './../images/bright.svg'
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import Slider from "react-slick";

export default function Banner() {
  const [active, setActive] = useState(false);
  // Create a ref for the banner section
  const bannerRef = useRef(null);

  // var settings = {
  //   dots: false,
  //   infinite: true,
  //   nav: false,
  //   autoplay:true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows:false,
  // };



  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setActive(false); 
      } else {
        setActive(false); 
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const scrollToSectionWithOffset = (sectionId, yOffset) => {
    const section = document.getElementById(sectionId);
    if (section) {
      const elementPosition = section.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition - yOffset,
        behavior: "smooth",
      });
      setActive(false); // Close the mobile menu
    }
  };

  const scrollToQuotesSection = () => {
    scrollToSectionWithOffset("quotes", 200);
  };
  return (
    <div className="banners" ref={bannerRef}> {/* Add the ref here */}
      <div className="container">
        <div className="banner-section">
          <div className="row">
            <div className="col-xl-6 col-12">
              <div className="banner-content">
                <h6><img src={Bright} alt="bright"/>Manage your vendor Relationship at everyway of life</h6>
                <h1>Vendor Management Software System</h1>
                <p>Dealing with multiple vendors for different needs is not so easy, for this we have to leverage on a vendor management tool that helps drive more value out of vendor relationships. By installing this Vendor Management Software OEM companies can digitally


                Dealing with multiple vendors for different needs is not so easy, for this we have to leverage on a vendor management tool that helps drive more value out of vendor relationships. By installing this Vendor Management Software OEM companies can digitally


                </p>
                <div className="banner-button">
                  <Link to='https://www.vendorascmsoftware.com/about-us/' target="_blank" className="btn1">Learn More</Link>
                 
                  <Link to="/#quotes" onClick={scrollToQuotesSection} className="btn2">
                  Enquire Now
              </Link>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-12 cus-banner">
              {/* <Slider {...settings}> */}
                <div>
                  <img src={Banner1} alt="banner1"/>
                </div>
                {/* <div>
                  <img src={Banner1} alt="banner1"/>
                </div>
                <div>
                  <img src={Banner1} alt="banner1"/>
                </div> */}
              {/* </Slider> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
